import { Pipe, Injectable, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class FilterPipe {
    /**
     * @param {?} value
     * @param {?} key
     * @return {?}
     */
    static isFoundOnWalking(value, key) {
        let /** @type {?} */ walker = value;
        let /** @type {?} */ found = false;
        do {
            if (walker.hasOwnProperty(key) || Object.getOwnPropertyDescriptor(walker, key)) {
                found = true;
                break;
            }
        } while (walker = Object.getPrototypeOf(walker));
        return found;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static isNumber(value) {
        return !isNaN(parseInt(value, 10)) && isFinite(value);
    }
    /**
     * Checks function's value if type is function otherwise same value
     * @param {?} value
     * @return {?}
     */
    static getValue(value) {
        return typeof value === 'function' ? value() : value;
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    filterByString(filter) {
        if (filter) {
            filter = filter.toLowerCase();
        }
        return value => !filter || (value ? ('' + value).toLowerCase().indexOf(filter) !== -1 : false);
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    filterByBoolean(filter) {
        return value => Boolean(value) === filter;
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    filterByObject(filter) {
        return value => {
            for (const /** @type {?} */ key in filter) {
                if (key === '$or') {
                    if (!this.filterByOr(filter.$or)(FilterPipe.getValue(value))) {
                        return false;
                    }
                    continue;
                }
                if (!value || !FilterPipe.isFoundOnWalking(value, key)) {
                    return false;
                }
                if (!this.isMatching(filter[key], FilterPipe.getValue(value[key]))) {
                    return false;
                }
            }
            return true;
        };
    }
    /**
     * @param {?} filter
     * @param {?} val
     * @return {?}
     */
    isMatching(filter, val) {
        switch (typeof filter) {
            case 'boolean':
                return this.filterByBoolean(filter)(val);
            case 'string':
                return this.filterByString(filter)(val);
            case 'object':
                return this.filterByObject(filter)(val);
        }
        return this.filterDefault(filter)(val);
    }
    /**
     * Filter value by $or
     * @param {?} filter
     * @return {?}
     */
    filterByOr(filter) {
        return (value) => {
            const /** @type {?} */ length = filter.length;
            const /** @type {?} */ arrayComparison = (i) => value.indexOf(filter[i]) !== -1;
            const /** @type {?} */ otherComparison = (i) => this.isMatching(filter[i], value);
            const /** @type {?} */ comparison = Array.isArray(value) ? arrayComparison : otherComparison;
            for (let /** @type {?} */ i = 0; i < length; i++) {
                if (comparison(i)) {
                    return true;
                }
            }
            return false;
        };
    }
    /**
     * Default filterDefault function
     * @param {?} filter
     * @return {?}
     */
    filterDefault(filter) {
        return (value) => filter === undefined || filter == value;
    }
    /**
     * @param {?} array
     * @param {?} filter
     * @return {?}
     */
    transform(array, filter) {
        if (!array) {
            return array;
        }
        switch (typeof filter) {
            case 'boolean':
                return array.filter(this.filterByBoolean(filter));
            case 'string':
                if (FilterPipe.isNumber(filter)) {
                    return array.filter(this.filterDefault(filter));
                }
                return array.filter(this.filterByString(filter));
            case 'object':
                return array.filter(this.filterByObject(filter));
            case 'function':
                return array.filter(filter);
        }
        return array.filter(this.filterDefault(filter));
    }
}
FilterPipe.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe)(); };
FilterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "filterBy", type: FilterPipe, pure: false });
FilterPipe.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FilterPipe, factory: FilterPipe.ɵfac });
/** @nocollapse */
FilterPipe.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filterBy',
                pure: false
            }]
    }, {
        type: Injectable
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class FilterPipeModule {
}
FilterPipeModule.ɵfac = function FilterPipeModule_Factory(t) { return new (t || FilterPipeModule)(); };
FilterPipeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FilterPipeModule });
FilterPipeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [FilterPipe] });
/** @nocollapse */
FilterPipeModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterPipeModule, [{
        type: NgModule,
        args: [{
                declarations: [FilterPipe],
                providers: [FilterPipe],
                exports: [FilterPipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FilterPipeModule, { declarations: [FilterPipe], exports: [FilterPipe] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { FilterPipeModule, FilterPipe };

